import {addCompaniesApi} from '../../../service/feature-companies/feature-companies-api';
import {
    PostSelectorCompanyType,
    UseCompaniesSelectorHookType,
} from '../../../service/feature-companies/feature-companies-type';

// Which of the two tabs of the "brand or companies" field is active.
export enum PublicationCompaniesSourceEnum {
    Brand = 'brand',
    Companies = 'companies',
}

// Field names owned by PublicationBrandOrCompaniesField. Every publication form rendering it must
// declare them in its own form type.
export enum PublicationCompaniesSourceFieldsEnum {
    BrandId = 'brandId',
    CompaniesCount = 'companiesCount',
}

export type PublicationCompaniesSourceFormType = {
    brandId?: number | null;
    // Mirrors the companies-selector count so the required rule can validate the selection.
    companiesCount?: number;
};

// The API resolves companies from the selector, so the brand tab has to expand the brand into its
// companies before the publication is submitted. Awaited (unlike the selector's own
// fire-and-forget selectFiltered) so the request cannot race the create/update call.
export async function selectBrandCompanies(
    companiesSelector: UseCompaniesSelectorHookType<PostSelectorCompanyType>,
    brandId: number
): Promise<void> {
    await companiesSelector.deselectAll();

    await addCompaniesApi({
        selectorId: companiesSelector.selectorId,
        body: {brand_ids: [brandId]},
        feature: companiesSelector.feature,
    });
}
